<div class="datepicker">
  @if (labelPosition() === DatePickerLabelPosition.Outside) {
    <span class="button__label">{{ label() }}</span>
  }
  <button
    type="button"
    class="datepicker__button button"
    [attr.data-style]="style()"
    [attr.data-size]="size()"
    [attr.data-outline]="outline()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [disabled]="isDisabled()"
    (click)="toggleOpen()"
  >
    <i class="button__icon icon icon-calendar-days"></i>
    <span class="button__content">
      @if (labelPosition() === DatePickerLabelPosition.Inside) {
        <span class="button__content_label">{{ label() }}</span>
      }
      <span
        class="button__content_selected-time"
        [ngClass]="{ placeholder: !selectedDate() }"
      >
        {{ (selectedDate() | date: 'MMMM d, YYYY') || placeholder() }}
      </span>
    </span>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isCalendarOpen()"
    (overlayOutsideClick)="closeCalendar()"
  >
    <div class="datepicker__calendar calendar" [attr.data-style]="style()">
      <div class="calendar__header">
        <button class="calendar__header_button" (click)="onPrevClick()">
          <i class="icon icon-chevron-left"></i>
        </button>

        <div class="calendar__header_diapason diapason">
          <span class="diapason__month">{{ MONTHS[month()] }}</span>
          <span class="diapason__year">{{ year() }}</span>
        </div>

        <button class="calendar__header_button" (click)="onNextClick()">
          <i class="icon icon-chevron-right"></i>
        </button>
      </div>

      <div class="calendar__content">
        <div class="calendar__content_week">
          @for (weekDay of WEEK_DAYS; track $index) {
            <span class="calendar__content_week_label">{{ weekDay }}</span>
          }
        </div>

        @for (week of options(); track $index) {
          <div class="calendar__content_week">
            @for (dayOption of week; track $index) {
              @let isDisabled = isDateDisabled(dayOption);

              @let isActive = dayOption.date === selectedDate();

              <button
                class="calendar__content_day"
                [disabled]="isDisabled"
                [ngClass]="[dayOption.dayMonth, isActive ? 'active' : '']"
                (click)="onDateClick(dayOption)"
              >
                <span class="calendar__content_day_label">
                  {{ dayOption.date.getDate() }}
                </span>
              </button>
            }
          </div>
        }
      </div>
    </div>
  </ng-template>
</div>
